// @flow weak

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import BannersList   from './BannersList';

export default BannersList;



// WEBPACK FOOTER //
// ./src/app/views/banners/index.js